import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestScannerResultTemplatesGet = {
    path: "/scanner/result/templates",
    method: RouteHttpVerb.GET
};
